module.exports = __webpack_public_path__ + "img/menu1_banner02.24d6d7b2.png";